export default __webpack_public_path__ + "static/skateMan-101792aca61d5d16b13fec9bc0800155.png";